import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../utils/Hooks";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { RequestStatus } from "../../utils/Enums";
import {
    deleteClient,
    getCurrentClient,
    resetDeleteClientStatus,
} from "../../store/reducers/ClientsSlice";
import Breadcrumbs from "../common/Breadcrumbs";
import { LoggedInView } from "../common/LoggedInView";
import { BreadcrumbLink } from "../../models/BreadcrumbLink";

interface DeleteClientScreenProps {}

export const DeleteClientScreen: React.FC<DeleteClientScreenProps> = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const clientsState = useAppSelector((state) => state.clients);
    const requestStatus: RequestStatus = clientsState.deleteClientStatus;

    const { id } = useParams();

    const breadcrumbLinks: BreadcrumbLink[] = [
        { text: "Kliendid", url: "/clients" },
        { text: "Kliendi kustutamine", url: "/clients/delete" },
    ];

    useEffect(() => {
        dispatch(resetDeleteClientStatus());
    }, [location]);

    const handleConfirm = () => {
        dispatch(deleteClient({ id }));
    };

    const handleCancel = () => {
        navigate(-1);
    };

    useEffect(() => {
        dispatch(getCurrentClient({ id }));
    }, [id]);

    const showSuccess = () => {
        return (
            <div className="message msg-ok">
                <div>
                    <h2>Klient kustutatud</h2>
                </div>
            </div>
        );
    };

    const showConfirm = () => {
        return (
            <div className="message" style={{ textAlign: "center" }}>
                <div>
                    <h2>
                        Oled kindel, et soovid kliendi{' '}
                        <em>{clientsState?.currentClient?.name ?? ""}</em> kustutada?
                    </h2>
                    <p>
                        <form method="post" id="delete_form" name="delete_form">
                            <input type="hidden" name="yes" value="yes" />
                            <button type="button" onClick={handleConfirm}>
                <span>
                  <strong>Jah</strong>
                </span>
                            </button>
                            <button type="button" onClick={handleCancel}>
                                Ei
                            </button>
                        </form>
                    </p>
                </div>
            </div>
        );
    };

    return (
        <LoggedInView fullWidth={false}>
            <Breadcrumbs links={breadcrumbLinks} />
            {requestStatus === RequestStatus.Success && showSuccess()}
            {requestStatus !== RequestStatus.Success && showConfirm()}
        </LoggedInView>
    );
};